/**
 * The line that draws this window's own surfaces — the card it is made of, and the strip naming the
 * employee chosen inside it. One step lighter than the `base-100` the module uses elsewhere, which
 * is the design's choice for this window. Stated here once so both surfaces can never drift and so
 * the choice comes back in one line.
 */
export const SURFACE_BORDER = 'border border-base-50';
